import moment from "moment";
import {
  Icon,
  KeyValueList,
  NoData,
  RenderWhen,
  Time
} from "../../../../../../../components";
import { UploadSourceData } from "../../../../sources/@types/UploadSource";

import ExpandableOverlay from "../../../../../../network/components/common/ExpandableOverlay";
import styles from "../sources.module.scss";

type Props = {
  uploadSource?: UploadSourceData;
};

interface EdrInfo {
  edrSource?: string;
  edrDetectedTime?: string;
  edrFilepaths?: string[];
  edrDescription?: string;
  edrHostPlatform?: string;
  edrHost?: string;
  edrUser?: string;
  edrProcessInfo?: string;
  edrEventUrl?: string;
  edrSeverity?: number;
  edrSeverityName?: string;
}
const SourceInfo = ({ uploadSource }: Props) => {
  const data = uploadSource?.upload_metadata.additional_data as EdrInfo;
  return (
    <>
      <KeyValueList className="flex flex-column flex-gap-2 overflow-hidden">
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="Source:"
          value={
            <RenderWhen
              condition={Boolean(data?.edrSource)}
              fallback={<NoData />}
            >
              <span>
                {data?.edrSource}
                <RenderWhen condition={!!data?.edrEventUrl}>
                  <a href={data?.edrEventUrl} target="_blank" rel="noreferrer">
                    <Icon className={styles.icon} name="open-in-new" />
                  </a>
                </RenderWhen>
              </span>
            </RenderWhen>
          }
          data-testid="sources_info_source_link"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="Detection Time:"
          value={<Time time={data?.edrDetectedTime} />}
          data-testid="sources_info_detection_time"
        />

        <KeyValueList.Item
          label="File Names and Paths:"
          value={
            <span>
              <RenderWhen
                condition={Boolean(data?.edrFilepaths?.length)}
                fallback={<NoData />}
              >
                <ExpandableOverlay
                  className={styles.filepaths}
                  renderKey="file-paths"
                  placement="left"
                  items={data?.edrFilepaths || []}
                />
              </RenderWhen>
            </span>
          }
        />
        <KeyValueList.Item
          label="Detection Information:"
          value={<p style={{ display: "inline" }}>{data?.edrDescription}</p>}
          data-testid="sources_info_description"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="Host Information:"
          value={data?.edrHost || <NoData />}
          data-testid="sources_info_host"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="User Information:"
          value={data?.edrUser || <NoData />}
          data-testid="sources_info_user"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="Severity:"
          value={data?.edrSeverity || <NoData />}
          data-testid="sources_info_severity"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="Process Info:"
          value={data?.edrProcessInfo || <NoData />}
          data-testid="sources_info_process"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="Platform:"
          value={data?.edrHostPlatform || <NoData />}
          data-testid="sources_info_platform"
        />
      </KeyValueList>
    </>
  );
};

export default SourceInfo;
